var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecondPlaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 0.732429C15.5235 0.285847 16.4765 0.285848 17.25 0.73243L29.9054 8.03905C30.6789 8.48564 31.1554 9.31095 31.1554 10.2041V24.8174C31.1554 25.7105 30.6789 26.5358 29.9054 26.9824L17.25 34.2891C16.4765 34.7356 15.5235 34.7356 14.75 34.2891L2.09455 26.9824C1.32105 26.5358 0.844556 25.7105 0.844556 24.8174V10.2041C0.844556 9.31095 1.32105 8.48564 2.09456 8.03905L14.75 0.732429Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 0.732429C15.5235 0.285847 16.4765 0.285848 17.25 0.73243L29.9054 8.03905C30.6789 8.48564 31.1554 9.31095 31.1554 10.2041V24.8174C31.1554 25.7105 30.6789 26.5358 29.9054 26.9824L17.25 34.2891C16.4765 34.7356 15.5235 34.7356 14.75 34.2891L2.09455 26.9824C1.32105 26.5358 0.844556 25.7105 0.844556 24.8174V10.2041C0.844556 9.31095 1.32105 8.48564 2.09456 8.03905L14.75 0.732429Z",
    fill: "url(#paint0_linear_1918_2837)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7502 4.06544C15.5237 3.61886 16.4767 3.61886 17.2502 4.06544L27.0189 9.70539C27.7924 10.152 28.2689 10.9773 28.2689 11.8705V23.1504C28.2689 24.0435 27.7924 24.8689 27.0189 25.3154L17.2502 30.9554C16.4767 31.402 15.5237 31.402 14.7502 30.9554L4.98147 25.3154C4.20797 24.8689 3.73147 24.0435 3.73147 23.1504V11.8705C3.73147 10.9773 4.20797 10.152 4.98147 9.7054L14.7502 4.06544Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7502 4.06544C15.5237 3.61886 16.4767 3.61886 17.2502 4.06544L27.0189 9.70539C27.7924 10.152 28.2689 10.9773 28.2689 11.8705V23.1504C28.2689 24.0435 27.7924 24.8689 27.0189 25.3154L17.2502 30.9554C16.4767 31.402 15.5237 31.402 14.7502 30.9554L4.98147 25.3154C4.20797 24.8689 3.73147 24.0435 3.73147 23.1504V11.8705C3.73147 10.9773 4.20797 10.152 4.98147 9.7054L14.7502 4.06544Z",
    fill: "url(#paint1_linear_1918_2837)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.7502 4.06544C15.5237 3.61886 16.4767 3.61886 17.2502 4.06544L27.0189 9.70539C27.7924 10.152 28.2689 10.9773 28.2689 11.8705V23.1504C28.2689 24.0435 27.7924 24.8689 27.0189 25.3154L17.2502 30.9554C16.4767 31.402 15.5237 31.402 14.7502 30.9554L4.98147 25.3154C4.20797 24.8689 3.73147 24.0435 3.73147 23.1504V11.8705C3.73147 10.9773 4.20797 10.152 4.98147 9.7054L14.7502 4.06544Z",
    fill: "url(#paint2_radial_1918_2837)",
    fillOpacity: 0.8,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6244 23.7628L11.1204 23.7988V21.6388L15.5124 17.9848C16.9344 16.8148 17.5284 15.9868 17.5284 14.8888C17.5284 13.5388 16.8624 12.8188 15.6744 12.8188C14.4324 12.8188 13.7124 13.6648 13.7124 15.1588H10.8144C10.8144 12.1708 12.7224 10.2268 15.6564 10.2268C18.6984 10.2268 20.5164 11.8648 20.5164 14.7088C20.5164 16.5268 19.4184 18.0028 17.7624 19.3888L15.7644 21.0628H20.6244V23.7628Z",
    fill: "#FDFEFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1918_2837",
    x1: -0.541423,
    y1: 8.55312,
    x2: 36.8356,
    y2: 33.0617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0648623,
    stopColor: "#99DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234907,
    stopColor: "#BDDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#D0C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747552,
    stopColor: "#C4C1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913698,
    stopColor: "#848DC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1918_2837",
    x1: 2.60949,
    y1: 10.259,
    x2: 32.8671,
    y2: 30.0993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0648623,
    stopColor: "#99DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234907,
    stopColor: "#BDDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#D0C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747552,
    stopColor: "#C4C1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913698,
    stopColor: "#848DC7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1918_2837",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14 16) rotate(2.81383) scale(30.7681 24.9496)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A4F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#8A0FBB",
    stopOpacity: 0.498
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondPlaceIcon);
export default __webpack_public_path__ + "static/media/secondPlaceIcon.10881513ec2771966db234a2e4db1b0b.svg";
export { ForwardRef as ReactComponent };